import {
  useBatchLockState,
  useModelLockState,
} from "../locking/contexts/GoodLockProvider";

export { LockDebugger };

type Props = {
  // batchUuid: string;
};
const LockDebugger = (props: Props) => {
  const batchLockState = useBatchLockState();
  const modelLockState = useModelLockState();

  // const [filterByBatch, setFilterByBatch] = useState(false);

  return (
    // replace with <ToggleButton/>
    // <input type={'checkbox'} checked={filterByBatch} onChange={e => setFilterByBatch(e.target.checked)}   />
    <>
      <table>
        <thead>
          <tr>
            <th>Model UUID</th>
            <th>Locked By</th>
            <th>BC ID</th>
            <th>Root</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(modelLockState).map((modelUuid, i) => (
            <tr key={modelUuid + JSON.stringify(modelLockState[modelUuid]) + i}>
              <td>{modelUuid}</td>
              <td>{modelLockState[modelUuid][0]}</td>
              <td>{modelLockState[modelUuid][1]}</td>
              <td>{modelLockState[modelUuid][2] + ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <table>
        <thead>
          <tr>
            <th>Batch UUID</th>
            <th>Locked By</th>
            <th>BC ID</th>
            <th>Root</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(batchLockState).map((batchUuid, i) => (
            <tr key={batchUuid + JSON.stringify(batchLockState[batchUuid]) + i}>
              <td>{batchUuid}</td>
              <td>{batchLockState[batchUuid][0]}</td>
              <td>{batchLockState[batchUuid][1]}</td>
              <td>{batchLockState[batchUuid][2] + ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};
